module.exports = __webpack_public_path__ + "static/media/tlb.2168ffbb.jpg";